import BaseAPI from "api/BaseAPI";

class ProductReservation extends BaseAPI {
	
	
	getProductsReservations = (page) => {
		let params = {};
		if(page > 0) {
			params["page"] = page;
		}
		return this.init().get("/account/productreservation", {params});
	};

	async getProductsReservationDetail(productId) {
		try {
			var t = await this.init().get("/account/productreservation/"+productId, {});
			return t;
		} catch(error) {
			console.log( error );
		}
		return false;
	}

	async setStateForReservation(productId, state) {
		try {
			var postObj = {state : state}
			var t = await this.init().post("/account/setStateForProductReservation/"+productId, postObj);
			return t;
		} catch(error) {
			console.log( error );
		}
		return false;
	}

	
	getProductsReservationsForLoggedinUser = (page) => {
		let params = {};
		if(page > 0) {
			params["page"] = page;
		}
		return this.init().get("/account/getReservationsForLoggedInUser", {params});
	};
	
	cancelProductReservationForLoggedInUser = (reservationId) => {
		return this.init().post("/account/cancelReservationForLoggedInUser/"+reservationId, {});
	};	
}

export default new ProductReservation();